import React, { useMemo, useEffect } from 'react';
import { SelectCard } from '@hum/legacy-ui';
import { useField, useForm } from '@hum/common/src/modules/form';
import {
  getCompany,
  updateCompanyTestAccount,
  useApiMutation,
  useApiQuery,
} from '@hum/api';

const useInternalConfig = ({ companyId }: { companyId: string }) => {
  const { data: company } = useApiQuery(getCompany, {
    params: { uuid: companyId },
  });
  const { mutate: updateCompany } = useApiMutation(updateCompanyTestAccount);
  const initialValues = useMemo(() => {
    return { isTestAccount: Boolean(company?.application.isTestAccount) };
  }, [company?.application.isTestAccount]);

  const form = useForm({
    initialValues,
    onSubmit: async (fields) => {
      // form is submitted once automatically
      if (form.submitCount > 1) {
        updateCompany({
          companyId: company?.uuid,
          isTestAccount: fields.isTestAccount,
        });
      }
    },
  });

  useEffect(() => {
    form.submitForm();
  }, [form.values.isTestAccount]);

  const isTestAccount = useField('isTestAccount', 'checkbox', form).input;

  return {
    form,
    isTestAccount,
  };
};

export const InternalConfig = ({ companyId }: { companyId: string }) => {
  const { form, isTestAccount } = useInternalConfig({ companyId });
  return (
    <>
      <SelectCard
        form={form}
        checkbox={isTestAccount}
        checkboxId="isTestAccount"
        checkboxIsToggle
        title={<h4>Is this a test account?</h4>}
        description={
          <p>If checked, this company won't show up in Heap or Mode reports.</p>
        }
      />
    </>
  );
};
